export const APP_CUSTOMER_TYPE = "/customer-type";
export const APP_EVENT_TYPE = "/event-type";
